// Shared, framework-independent flag: is the Chat module (WorkspaceChats) currently mounted?
//
// WorkspaceChats already owns a unified call WebSocket + its own incoming-call banner. The
// global IncomingCallProvider subscribes here so that, while Chat is on screen, the global
// layer releases its WebSocket and hides its banner — guaranteeing exactly ONE listener and
// ONE banner per session (Synex Calling V2, Phase 7). No React required; mirrors callState.js.

let chatActive = false;
const listeners = new Set();

export function setChatModuleActive(active) {
  const next = !!active;
  if (next === chatActive) return;
  chatActive = next;
  listeners.forEach((fn) => {
    try {
      fn(chatActive);
    } catch {
      /* ignore listener errors */
    }
  });
}

export function isChatModuleActive() {
  return chatActive;
}

export function subscribeChatModule(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
